import 'bootbox';

export default (function () {
    window.bootbox = require('bootbox');
}())



// WEBPACK FOOTER //
// ./resources/js/admin/bootbox/index.js